import { AuthContext, AuthProvider, IAuthContext, TAuthConfig } from 'react-oauth2-code-pkce'
import React, { useContext, useState, useEffect } from 'react'


  
const LogoutPage = () => {
  const { logOut, token } = useContext(AuthContext);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    const performLogout = async () => {
      if (isLoggingOut) return; // Prevent multiple logout attempts
      
      setIsLoggingOut(true);
      
      try {
        // Call the logout function
        await logOut();
        
        // Clear all localStorage items
        localStorage.clear();
        
        // Clear session storage as well
        sessionStorage.clear();
        
        // Wait a bit to ensure logout is complete
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Force redirect to home page
        window.location.replace('/');
      } catch (error) {
        console.error('Logout error:', error);
        // Even if there's an error, clear storage and redirect
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace('/');
      }
    };
    
    performLogout();
  }, []); // Empty dependency array - only run once on mount

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <div>Logging out...</div>
      <div className="animate-spin" style={{ 
        width: '40px', 
        height: '40px', 
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #3498db',
        borderRadius: '50%'
      }}></div>
    </div>
  );
};

export default LogoutPage;